export const nav = {
    permission: 'ata.storage:ver',
    section: 'Settings',
    title: 'Storage',
    icon: 'cloud',
    route: '/storage',
    sequence: 15, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/storage',
        name: 'storage',
        component: () => import('./pages/StoragePage.vue'),
        meta: { requiresAuth: true, permission: 'ata.storage:ver' },
    },
];
